import {DrawerBodyDefaultBox} from "./drawer-body.default.box";

export const DrawerBodyBox = DrawerBodyDefaultBox;
